import { TLocalizationKey } from 'types/i18n';

export const FEE_TYPE: Record<string, TLocalizationKey> = {
  BAG_FEE: 'bagFee',
};
